export const CodeSendHandlersIds = {
    HANDLER_SMS: 1,
    HANDLER_GOOGLE: 2,
    HANDLER_WORD: 3,
    HANDLER_EMAIL: 4,
    HANDLER_PASSWORD: 5,
    HANDLER_CAPTCHA: 6,
    HANDLER_GOOGLE_CAPTCHA: 7,
    HANDLER_WHATS_APP: 8,
    HANDLER_TELEGRAM: 9,
    HANDLER_FLASHCALL: 10,
    HANDLER_VOICECALL: 11
};
